<section class="library-header">
  <ng-template [ngIf]="isBackVisible">
    <a [routerLink]="backRouteUrl" class="back">
      <app-icon [width]="10" [height]="14" file="chevron" icon="left"></app-icon>
    </a>
  </ng-template>

  <div class="bg-wrap">
    <img class="bg-image-img" [src]="assetsUrl(imageUrl)" [attr.alt]="baseTitle | translate">
  </div>

  <app-sticky [scrollThreshold]="scrollThreshold" [afterScrollThreshold]="120" [onlyMobile]="true">
    <div class="title-block" [class.margin-bottom]="isPanes">
      <div class="title-wrap">
        <h1 class="title">
          <b *ngFor="let title of titles; trackBy: trackByFn">{{ title | translate }}</b>
          <b *ngIf="titles.length > 0 && (baseTitle | translate) !== ''"> / </b>
          <b>{{ baseTitle | translate }}</b>
        </h1>
        <div *ngIf="isTeacher && onCreateTitle() && hideMobileCreateButton()" class="action">
          <ng-template [ngIf]="!isTutorsPage || !isTeacher">
            <on-ui-button class="primary"
                          [attr.data-test]="onCreateTitle() | translate"
                          [label]="onCreateTitle()"
                          (onclick)="onCreated()">
            </on-ui-button>

            <div class="action-item" (click)="onCreated()">
              <div class="action-icon-wrap">
                <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="title-block-breadcrumbs">
        <ng-template [ngIf]="canBreadcrumbs()" [ngIfElse]="gap">
          <app-breadcrumbs displayMode="breadCrumbsOnly"></app-breadcrumbs>
        </ng-template>
        <ng-template #gap>
          <div class="gap"></div>
        </ng-template>
      </div>
    </div>

    <div class="action-block" *ngIf="!!panesList?.length && !utilsService.isContentPage">
      <app-pane *ngFor="let pane of panesList; trackBy: trackByFn" [item]="pane" (loadFinished)="loadFinished(pane, $event)"></app-pane>
    </div>
  </app-sticky>
</section>

<app-modal *ngIf="deviceService.isDesktop() && meetingFormOpen"
           (closed)="onToggleMeetingForm()">
  <app-modal-body>
    <app-meeting-form-wrapper [caller]="'app-library-header'"></app-meeting-form-wrapper>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && meetingFormOpen"
                  (closed)="onToggleMeetingForm()">
  <app-mobile-modal-body>
    <app-meeting-form-wrapper [caller]="'app-library-header'"></app-meeting-form-wrapper>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="deviceService.isDesktop() && schoolFormOpen"
           (closed)="onToggleSchoolForm()">
  <app-modal-body>
    <app-school-form [modalDisplayMode]="true"
                     (changed)="onToggleSchoolForm()">
    </app-school-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && schoolFormOpen"
                  (closed)="onToggleSchoolForm()">
  <app-mobile-modal-body>
    <app-school-form [modalDisplayMode]="true"
                     (changed)="onToggleSchoolForm()">
    </app-school-form>
  </app-mobile-modal-body>
</app-mobile-modal>
